export const translations = {
  // Menu items
  myActivities: 'Minhas atividades',
  taskControl: 'Novas demandas',
  minhasNotas: 'Novas demandas',
  timeUsage: 'Meu uso do tempo',
  chat: 'Chat',
  projects: 'Projetos',
  nankinInsights: 'Insights do Nankin',
  productSpec: 'Especificação de Produtos',
  gettingStarted: 'Primeiros passos',
  helpAndSupport: 'Ajuda e Suporte',
  
  // Activities submenu
  strategic: 'Visão Estratégica',
  monitoring: 'Monitoramento',
  activities: 'Atividades',
  'activities-2': 'Atividades 2',
  calendar: 'Calendário',
  
  // Tasks submenu
  inbox: 'Entrada',
  today: 'Hoje',
  upcoming: 'Próximos dias',
  completed: 'Concluído',
  
  // Time submenu
  tracker: 'Rastreador',
  projectPlan: 'Plano por Projeto',
  plannedVsActual: 'Plano x Realizado',
  reports: 'Relatórios',
  tags: 'Tags',

  // Finance submenu
  reconciliation: 'Conciliação',
  'financial-movements': 'Movimentações',
  'financial-dashboard': 'Dashboard Financeiro',
  'financial-projects': 'Projetos',
  'financial-registers': 'Cadastros',
  'financial-calendar': 'Calendário',
  'financial-reports': 'Relatórios',

  // Common actions
  add: 'Adicionar',
  edit: 'Editar',
  delete: 'Excluir',
  cancel: 'Cancelar',
  save: 'Salvar',
  close: 'Fechar',
  
  // Settings
  settings: 'Configurações',
  language: 'Idioma',
  selectLanguage: 'Selecione o idioma da interface',
  languageChanged: 'O idioma selecionado será aplicado em toda a interface do sistema'
} as const;